import React, { useState } from 'react';
import Module from '../../../layout/Module';
import { useSelector } from 'react-redux';
import SyncDialog from './Sync/Sync';
import List from './List/List';
import MenuButton from '../../../button/MenuButton';
import FilterButtonMaintenance from './Filter/Button';
import ButtonStartIcon from '../../../button/ButtonStartIcon';

const Maintenance = () => {
  const [modal, setModal] = useState(null);
  const permission = useSelector((state) => state?.session?.permissions);

  const optionsData = (module) => {
    if (module === 'users') {
      return [
        {
          id: `disable-${module}`,
          label: `Disable list ${module}`,
          permissions: true,
          onClick: () => setModal({ type: `disable-${module}`, module })
        },
        {
          id: `sync-${module}-students`,
          label: `Sync list students ${module}`,
          divider: true,
          permissions: true,
          onClick: () => setModal({ type: module, module, userType: 'Students' })
        },
        {
          id: `sync-${module}-parents`,
          label: `Sync list parents ${module}`,
          permissions: true,
          onClick: () => setModal({ type: module, module, userType: 'Parents' })
        },
        {
          id: `sync-${module}-teachers`,
          label: `Sync list teachers   ${module}`,
          permissions: true,
          onClick: () => setModal({ type: module, module, userType: 'Teachers' })
        }
      ];
    }

    return [
      {
        id: `disable-${module}`,
        label: `Disable list ${module}`,
        permissions: true,
        onClick: () => setModal({ type: `disable-${module}`, module })
      },
      {
        id: `sync-${module}`,
        label: `Sync list ${module}`,
        divider: true,
        permissions: true,
        onClick: () => setModal({ type: module, module })
      }
    ];
  };
  return (
    <Module>
      <Module.Header title='Maintenance' titleLink={'/dashboard/maintenance'}></Module.Header>
      <Module.Body>
        <Module.BodyHeader className='border-b border-b-2 border-primary justify-between'>
          <FilterButtonMaintenance />
          <div className='flex gap-4'>
            {permission?.['users-maintenance'] && (
              <MenuButton
                id='users-maintenance'
                icon={['far', 'users-cog']}
                title='Users'
                color='primary'
                items={optionsData('users')}
              />
            )}
            {permission?.['subject-maintenance'] && (
              <ButtonStartIcon
                id='subject-maintenance'
                startIcon='badge-check'
                children='Subjects'
                color='primary'
                onClick={() => setModal({ type: 'subjects', module: 'subjects' })}
              />
            )}
            {permission?.['classes-maintenance'] && (
              <MenuButton
                id='classes-maintenance'
                icon={'users-class'}
                title='classes'
                color='primary'
                items={optionsData('classes')}
              />
            )}
          </div>
        </Module.BodyHeader>
        <Module.BodyContainer classNameWrapper='overflow-auto'>
          <List />
        </Module.BodyContainer>
      </Module.Body>
      {modal && (
        <SyncDialog
          show={!!modal}
          onClose={() => setModal(null)}
          type={modal?.type}
          module={modal?.module}
          userType={modal?.userType}
        />
      )}
    </Module>
  );
};

export default Maintenance;
